import React, { useEffect } from 'react'
import generalClasses from './Wizard.module.css'
import classes from './ConfirmationStep.module.css'
import { Button, ButtonVariants } from '../../components/Button/Button'
import { Link, useHistory } from 'react-router-dom'
import congratulationsImage from '../../assets/images/congratulations-image.svg'
import { useSelector, useDispatch } from 'react-redux'
import { wizardSelectors } from './wizardSlice'
import { cartSelectors } from '../Cart/cartSlice'
import { deselectPlan } from '../Cart/cartApi'
import {
    markCurrentWizardStepDone,
    isWizardStepComplete,
    jumpToWizardStep,
} from './wizardLogic'
import { userActions } from '../../redux/userSlice'

const ConfirmationStep = () => {
    const { returnURL } = useSelector(wizardSelectors.wizardState)
    const dispatch = useDispatch()
    const { push } = useHistory()
    const selectedPlan = useSelector(cartSelectors.selectedPlan)
    const cartItems = useSelector(cartSelectors.cartItems)
    const itemDetails = useSelector(cartSelectors.cartItemDetails)
    const planDetails = itemDetails[selectedPlan?.detailId]

    useEffect(() => {
        if (isWizardStepComplete('confirmation')) {
            push('/app/dashboard')
        }

        if (!isWizardStepComplete('checkout')) {
            jumpToWizardStep('checkout')
        }
    }, [push])

    function cleanup() {
        markCurrentWizardStepDone()
        dispatch(deselectPlan())
    }

    function goToReturnURL() {
        cleanup()
        dispatch(userActions.resetRedirectUrl())
        push(returnURL)
    }

    function goToCart() {
        cleanup()
        push('/app/cart')
    }

    return (
        <div className={generalClasses.wizardContent}>
            <div className={generalClasses.wizardContentCentered}>
                <img
                    className={classes.messageImage}
                    src={congratulationsImage}
                    alt=""
                />
                <h5 className={classes.messageTitle}>Congratulations</h5>
                <p className={classes.messageText}>
                    Your registration was successful, you are now subscribed to
                    the {planDetails?.title} plan. Click{' '}
                    <Link className={classes.link} to="/plans">
                        here
                    </Link>{' '}
                    to view other plans
                </p>
                {cartItems.length > 0 && (
                    <p className={classes.messageText}>
                        You have items in your cart, would you like to proceed
                        to checkout?
                    </p>
                )}
                <div className={classes.buttons}>
                    <Button bold onClick={goToReturnURL}>
                        Proceed
                    </Button>
                    {cartItems.length > 0 && (
                        <Button
                            bold
                            onClick={goToCart}
                            variant={ButtonVariants.secondaryOutline}
                        >
                            Go to cart
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ConfirmationStep
